export default __webpack_public_path__ + "static/media/ZZC_0762.e8465456.jpg";